import { fetchData } from '../../../http/Http';
import fetch from 'isomorphic-fetch';

export const fetchArticleById = async (articleId: string): Promise<any> => {
    const response = await fetchData(`/articles/${articleId}`, 'GET');
    return response.data;
};

export const fetchArticlesByCategoryId = async (
    id: string,
    limit: string = '20',
    page: string = '1',
    offset: string = '0',
) => {
    return await fetchData(
        `/articles/search?query=*&status=active&category=${id}&limit=${limit}&page=${page}&offset=${offset}`,
        'GET',
    );
};

export const fetchArticlesByTagId = async (id: string, limit: string = '20', page: string = '1') => {
    return await fetchData(`/v2/articles/search?query=*&status=active&tagIds=${id}&limit=${limit}&page=${page}`, 'GET');
};

export const fetchArticlesByAuthorId = async (id: string, limit: string = '20', page: string = '1') => {
    return await fetchData(
        `/v2/articles/search?query=*&status=active&authorIds=${id}&limit=${limit}&page=${page}`,
        'GET',
    );
};

export const fetchArticlesByText = async (text: string, limit: string = '20', page: string = '1') => {
    return await fetchData(`/v2/articles/search?query=${text}&status=active&limit=${limit}&page=${page}`, 'GET');
};

export const fetchLatestArticles = async (limit: string) => {
    const response = await fetchData(
        `/v2/articles/search?query=*&status=active&sort_direction=desc&limit=${parseInt(limit)}`,
        'GET',
    );
    return response.data;
};

export const fetchLatestArticlesProxy = async (limit: string) => {
    const response: any = await fetch(`${process.env.NEXT_PUBLIC_WEBSITE_URL}/api/related_articles?number=${limit}`, {
        method: 'GET',
    });
    return await response.json();
};

export const fetchLatestArticlesFromCategoryProxy = async (categoryId: string, limit: string) => {
    const response: any = await fetch(
        `${process.env.NEXT_PUBLIC_WEBSITE_URL}/api/related_articles?number=${limit}&category_id=${categoryId}`,
        { method: 'GET' },
    );
    return await response.json();
};

export const fetchImportantArticles = async (limit: string) => {
    return await fetchData(
        `/v2/articles/search?query=*&important=true&status=active&sort_direction=desc&limit=${parseInt(limit)}`,
        'GET',
    );
};
